// Basic
import { useEffect, useState } from 'react';
// Store & actions
import useRootOrganizationStore from '@/app/store/rootOrganization';
import useSimsStore from '@/app/store/modules/sims';
import actionsSims from '../../api/actionsSims';
// Components
import DataTable from '@/common-utils/components/renders/dataTable/DataTable';
// Common
import simGroupFields from '../../fields/simGroupFields';
import getInitialQuery from '@/common-utils/components/renders/dataTable/utils/getInitialQuery';
import mergeQuery from '@/common-utils/components/renders/dataTable/utils/mergeQuery';
import Permissions from '@/app/permissions/Permissions';
import { columnsSimGroups, columnsSimGroupsId } from './columnDef/columnsSimGroups';
import { SIMS_GROUP } from '../../api/apiUrls';
import PropTypes from 'prop-types';

/**
 * @param root0.filtersEventName
 * @returns {JSX} SimGroupsTable
 */
function SimGroupsTable({ filtersEventName }) {
    // Store
    const rootOrganization = useRootOrganizationStore(s => s.rootOrganization);
    const { refetchSimGroups: refetchFromStore, storeRefetchSimGroups, querySimGroups: queryStored, storeQuerySimGroups } = useSimsStore();

    // Constants
    const QUERY_PRESETS = {
        filters: [
            {
                key: simGroupFields.PROVIDER.altKey,
                value: rootOrganization.uuid,
                hidden: true
            }
        ]
    };
    const initialQuery = getInitialQuery(QUERY_PRESETS);

    // State
    const [query, setQuery] = useState(mergeQuery(initialQuery, queryStored));
    const [launchRefetch, setLaunchRefetch] = useState(true);

    // Api Calls
    const { data, isFetching, error, refetch } = actionsSims.getSimGroups(query, false);

    // Hooks
    useEffect(() => {
        if (rootOrganization && (launchRefetch || refetchFromStore)) {
            refetch();
            setLaunchRefetch(false);
            storeRefetchSimGroups(false);
        }
    }, [query, launchRefetch, refetchFromStore]);

    const allColumns = columnsSimGroups({ query, setQuery, queryStored, storeQuery: storeQuerySimGroups, setLaunchRefetch, filtersEventName });

    // Render
    return (
        <DataTable
            filtersEventName={filtersEventName}
            columns={allColumns}
            data={data}
            dataFetchingIsLoading={isFetching}
            error={error}
            refetch={refetch}
            columnsId={columnsSimGroupsId}
            initialQuery={initialQuery}
            query={query}
            setQuery={setQuery}
            queryStored={queryStored}
            storeQuery={storeQuerySimGroups}
            setLaunchRefetch={setLaunchRefetch}

            exportProps={{
                permissions: [
                    Permissions.EXPORT_SIMS.name
                ],
                api: SIMS_GROUP.EXPORT_GROUPS
            }}
        />
    );
}

SimGroupsTable.propTypes = {
    filtersEventName: PropTypes.string
};

export default SimGroupsTable;